import {
	Button,
	DatePicker,
	Input,
	Popconfirm,
	Popover,
	Select,
	Space,
	Switch,
	TimePicker,
	message,
} from 'antd'
import React, { useEffect, useState } from 'react'
import { View } from '../../../../styles/reactnative'
import { column_balance } from '../../../components/AdminUserModal/UserInfoTabs/column_balance'
import TableAPI from '../../../components/TableAPI'

import { CloseOutlined, FileSearchOutlined } from '@ant-design/icons'
import { IconInfoSquare } from '@tabler/icons'
import { column_balance_prev } from 'app/components/AdminUserModal/UserInfoTabs/column_balance_prev'
import SettingGroup from 'app/adminpages/AdminSystem/SettingGroup'
import dayjs from 'dayjs'
import jwtDecode from 'jwt-decode'
import API from '../../../../utils/api'
import { ENDTIME, STARTTIME } from '../../../constants/APIKEYS'
import { useToken } from '../../../hooks'
import { useUserGroup } from '../../../hooks/user/usergroups'
import { useUserList } from '../../../hooks/user/userlist'

const BalanceExChange = ({ title }) => {
	const { data: token } = useToken()

	const decodedToken: any = jwtDecode(token + '')
	const level = decodedToken?.level || null

	const [search, setSearch] = useState('')
	const [startDate, setStartDate] = useState<any>(null)
	const [endDate, setEndDate] = useState<any>(null)

	const [startTime, setStartTime] = useState<any>(STARTTIME)
	const [endTime, setEndTime] = useState<any>(ENDTIME)

	const [exceptType1, setExceptType1] = useState(true)
	const [exceptType2, setExceptType2] = useState(true)
	const [exceptType3, setExceptType3] = useState(false)
	const [exceptType4, setExceptType4] = useState(true)
	const [exceptType5, setExceptType5] = useState(true)

	const [defaultmaxData, setDefaultmaxData] = useState(100)

	const [old, setOld] = useState(false)
	const [prev, setPrev] = useState(false)
	const { type1 } = useUserGroup()

	const [group, setGroup] = useState<string[]>(['*'])

	const { usertype1 } = useUserList()

	useEffect(() => {
		let exceptType = ''
		if (exceptType1) exceptType += `${exceptType ? ',' : ''}-2`
		if (exceptType2) exceptType += `${exceptType ? ',' : ''}-1`
		if (exceptType3) exceptType += `${exceptType ? ',' : ''}-9`
		if (exceptType4) exceptType += `${exceptType ? ',' : ''}6, -10`
		if (exceptType5) exceptType += `${exceptType ? ',' : ''}7`
		setExceptType(exceptType)
	}, [exceptType1, exceptType2, exceptType3, exceptType4, exceptType5])

	const [exceptType, setExceptType] = useState('')
	const [userId, setUserId] = useState('')
	const [isAll, setIsAll] = useState(false)
	const order = ' id desc '

	const tempurl = `/admin/balance?t=
		${(startDate && `&startdate=${startDate}`) || ''}
		${(endDate && `&enddate=${endDate}`) || ''}
		${(startTime && `&starttime=${startTime}`) || ''}
		${(endTime && `&endtime=${endTime}`) || ''}
		${(exceptType && `&excepttype=${exceptType}`) || ''}
		${(userId && `&userid=${userId}`) || ''}
		${(group && group.length > 0 && `&group=${group.join(',')}`) || ''}
		${(isAll && `&isall=${isAll}`) || ''}
		${(order && `&order=${order}`) || ''}
		${(search && `&searchWord=${search}`) || ''}
		${old ? '&old=1' : ''}
	`

	let [url, setUrl] = useState('')

	//startdate, enddate, excepttype, userid, isall, type, order, searchWord, maxData, page

	return (
		<View style={{ width: '100%' }}>
			<Space
				direction="vertical"
				style={{
					width: '100%',
					padding: 10,
					background: '#fff',
					marginTop: 5,
					marginBottom: 5,
					borderRadius: 10,
					flex: 1,
					alignItems: 'flex-start',
				}}>
				<View style={{ flexDirection: 'row', alignSelf: 'flex-end' }}>
					<Space>
						<Space.Compact direction="horizontal">
							{level == 99 && (
								<Popconfirm
									okText={'갱신'}
									title={
										'부하가 생길수 있으니, 꼭 필요할때만 해주세요.'
									}>
									<Button
										onClick={() => {
											API.get(
												`/admin/balancereset2`,
												token + '',
												{}
											).then(res => {
												if (res.result.success) {
													message.success(
														'갱신되었습니다.'
													)
												} else {
													message.error(res.data.msg)
												}
											})
										}}
										size="small"
										type={'primary'}
										danger>
										정산갱신
									</Button>
								</Popconfirm>
							)}

							<SettingGroup
								group={group}
								setGroup={setGroup}
								defaultv='*'
								style={{ border: 'none', padding: 0, height: 'auto' }}
							/>
							<Popover
								trigger={'click'}
								content={
									<Space style={{ alignItems: 'center' }}>
										<Select
											defaultValue={''}
											style={{
												width: '100%',
												minWidth: 200,
											}}
											onChange={e => {
												setUserId(e)
											}}
											options={[
												{ value: '', label: '전체' },
												...(usertype1 || []),
											]}
										/>
									</Space>
								}>
								<Input
									placeholder="No"
									style={{ width: '100%', minWidth: 180 }}
									value={userId}
									onChange={e => {
										setUserId(e.target.value)
									}}
								/>
							</Popover>
							<Button
								onClick={() => {
									setUserId('')
								}}
								style={{ paddingTop: 0 }}
								size="small">
								{userId ? (
									<CloseOutlined />
								) : (
									<FileSearchOutlined />
								)}
							</Button>
						</Space.Compact>
						<Space.Compact direction="horizontal">
							<Input
								placeholder="검색"
								value={search}
								onChange={e => {
									setSearch(e.target.value)
								}}
							/>
							<Button
								onClick={() => {
									setSearch('')
								}}
								style={{ paddingTop: 0 }}
								size="small">
								{search ? (
									<CloseOutlined />
								) : (
									<FileSearchOutlined />
								)}
							</Button>
						</Space.Compact>
					</Space>
					<Space size="small">
						제외
						<Space
							size={'small'}
							style={{
								border: '1px solid #ccc',
								padding: 5,
								borderRadius: 5,
							}}>
							<Space.Compact
								size="small"
								style={{
									alignItems: 'center',
									whiteSpace: 'nowrap',
									fontSize: 10,
								}}>
								거절
								<Switch
									onChange={e => setExceptType1(e)}
									defaultChecked={exceptType1}
								/>
							</Space.Compact>
							<Space.Compact
								size="small"
								style={{
									alignItems: 'center',
									whiteSpace: 'nowrap',
									fontSize: 10,
								}}>
								대기
								<Switch
									onChange={e => setExceptType2(e)}
									defaultChecked={exceptType2}
								/>
							</Space.Compact>
							<Space.Compact
								size="small"
								style={{
									alignItems: 'center',
									whiteSpace: 'nowrap',
									fontSize: 10,
								}}>
								블랙
								<Switch
									onChange={e => setExceptType3(e)}
									defaultChecked={exceptType3}
								/>
							</Space.Compact>
							<Space.Compact
								size="small"
								style={{
									alignItems: 'center',
									whiteSpace: 'nowrap',
									fontSize: 10,
								}}>
								모의
								<Switch
									onChange={e => setExceptType4(e)}
									defaultChecked={exceptType4}
								/>
							</Space.Compact>

							<Space.Compact
								size="small"
								style={{
									alignItems: 'center',
									whiteSpace: 'nowrap',
									fontSize: 10,
								}}>
								페이크
								<Switch
									onChange={e => setExceptType5(e)}
									defaultChecked={exceptType5}
								/>
							</Space.Compact>
						</Space>
					</Space>

					<Space.Compact
						size="small"
						style={{
							alignItems: 'center',
							whiteSpace: 'nowrap',
							fontSize: 10,
						}}>
						전체회원
						<Switch
							onChange={e => setIsAll(e)}
							defaultChecked={isAll}
						/>
					</Space.Compact>
					{level == 99 && (
						<Space.Compact
							size="small"
							style={{
								alignItems: 'center',
								whiteSpace: 'nowrap',
								fontSize: 10,
							}}>
							구버전
							<Switch
								onChange={e => setOld(e)}
								defaultChecked={old}
							/>
						</Space.Compact>
					)}
					<Space.Compact
						size="small"
						style={{
							alignItems: 'center',
							whiteSpace: 'nowrap',
							fontSize: 10,
						}}>
						전일비교
						<Switch
							onChange={e => setPrev(e)}
							defaultChecked={prev}
						/>
					</Space.Compact>
				</View>

				<Space>
					<Space>
						기간
						<Space.Compact
							style={{
								alignItems: 'center',
								whiteSpace: 'nowrap',
								fontSize: 10,
							}}>
							<DatePicker
								onChange={e =>
									setStartDate(
										dayjs(e, 'YYYY-MM-DD').format(
											'YYYY-MM-DD'
										)
									)
								}
								defaultValue={
									startDate
										? dayjs(startDate, 'YYYY-MM-DD')
										: undefined
								}
							/>
							<DatePicker
								onChange={e =>
									setEndDate(
										dayjs(e, 'YYYY-MM-DD').format(
											'YYYY-MM-DD'
										)
									)
								}
								defaultValue={
									endDate
										? dayjs(endDate, 'YYYY-MM-DD')
										: undefined
								}
							/>
							- 정산시간
							<TimePicker
								onChange={e =>
									setStartTime(
										dayjs(e, 'HH:mm:ss').format('HH:mm:ss')
									)
								}
								defaultValue={
									startTime
										? dayjs(startTime, 'HH:mm:ss')
										: undefined
								}
							/>
							<TimePicker
								onChange={e =>
									setEndTime(
										dayjs(e, 'HH:mm:ss').format('HH:mm:ss')
									)
								}
								defaultValue={
									endTime
										? dayjs(endTime, 'HH:mm:ss')
										: undefined
								}
							/>
						</Space.Compact>
					</Space>

					<Space
						style={{
							border: '1px solid #ccc',
							padding: 5,
							borderRadius: 5,
						}}>
						기본 조회갯수
						<Select
							defaultValue={defaultmaxData}
							onChange={e => setDefaultmaxData(e)}
							style={{ width: 120 }}>
							<Select.Option value={100}>100</Select.Option>
							<Select.Option value={500}>500</Select.Option>
							<Select.Option value={1000}>1000</Select.Option>
							<Select.Option value={10000}>10000</Select.Option>
						</Select>
						<Button
							onClick={() => setUrl(tempurl)}
							type="primary"
							danger
							icon={<IconInfoSquare />}>
							{' '}
							조회
						</Button>
					</Space>

					<Button
						onClick={() => {
							API.getBlob(tempurl + '&excel=1', token + '', {})
								.then(async (res: any) => {
									const blob = await res.blob()

									var _url = window.URL.createObjectURL(blob)

									console.log(_url)

									if (_url) {
										// 다운로드를 트리거하기 위한 링크 생성
										const link = document.createElement('a')
										link.href = _url
										link.download = '정산현황.xlsx'
										document.body.appendChild(link)
										link.click()
										document.body.removeChild(link)
										window.URL.revokeObjectURL(_url) // 메모리 해제
									} else {
										message.error(
											'파일을 다운로드할 수 없습니다.'
										)
									}
								})
								.catch(err => {
									console.error('다운로드 중 오류 발생:', err)
									message.error(
										'파일 다운로드 중 오류가 발생했습니다.'
									)
								})
						}}
						type="primary"
						danger
						icon={<IconInfoSquare />}>
						{' '}
						엑셀다운로드
					</Button>
				</Space>
			</Space>

			{url ? (
				<TableAPI
					title={title}
					defaultMaxData={defaultmaxData}
					columns={prev ? column_balance_prev : column_balance}
					usermodal={true}
					height={'default'}
					apikey={url + '&t='}
					footer={1}
				/>
			) : (
				<Button
					onClick={() => {
						setUrl(tempurl)
					}}
					type="primary">
					검색
				</Button>
			)}
		</View>
	)
}

export default BalanceExChange
